var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _ellipse26, _ellipse27, _ellipse28, _ellipse29, _ellipse30, _ellipse31, _ellipse32, _ellipse33, _ellipse34, _ellipse35, _ellipse36, _ellipse37, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup54(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 572,
    height: 572,
    viewBox: "0 0 572 572",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M261.06 475.65C251.897 474.559 241.979 472.525 232.028 469.696C222.076 466.866 212.343 463.313 203.536 459.294L208.383 457.358C215.825 460.755 224.05 463.758 232.459 466.149C240.868 468.54 249.25 470.259 256.992 471.18L261.06 475.65Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M367.501 463.832C359.034 467.499 349.439 470.73 339.415 473.291C329.391 475.852 319.191 477.677 309.558 478.633L312.773 474.523C320.913 473.714 329.532 472.172 338.003 470.008C346.474 467.844 354.582 465.114 361.737 462.015L367.501 463.832Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M253.901 96.9395C263.032 95.6112 273.138 94.9978 283.483 95.144C293.828 95.2903 304.15 96.1924 313.699 97.7848L309.521 100.913C301.453 99.5674 292.73 98.8051 283.988 98.6815C275.247 98.5579 266.706 99.0763 258.991 100.199L253.901 96.9395Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_70_6)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 286,
    cy: 286,
    rx: 215.478,
    ry: 215.478,
    transform: "rotate(-1.21534 286 286)",
    fill: "#22EAEA",
    fillOpacity: 0.08
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M455.951 282.394C457.942 376.255 383.467 453.959 289.606 455.95C195.745 457.941 118.042 383.466 116.05 289.605C114.059 195.745 188.534 118.041 282.395 116.05C376.256 114.059 453.959 188.534 455.951 282.394ZM123.723 289.443C125.624 379.066 199.82 450.179 289.443 448.278C379.067 446.376 450.18 372.181 448.278 282.557C446.377 192.934 372.181 121.821 282.558 123.722C192.934 125.623 121.821 199.819 123.723 289.443Z",
    fill: "#22EAEA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M108.163 352.615C104.959 343.962 102.25 334.207 100.234 324.059C98.2181 313.911 96.9462 303.628 96.5109 293.957L100.442 297.39C100.81 305.561 101.885 314.252 103.588 322.826C105.292 331.401 107.581 339.645 110.289 346.957L108.163 352.615Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M165.259 436.388C158.076 430.596 150.754 423.604 143.826 415.92C136.899 408.236 130.541 400.054 125.215 391.97L130.349 392.905C134.849 399.736 140.222 406.65 146.076 413.144C151.93 419.637 158.118 425.546 164.188 430.44L165.259 436.388Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M440.665 407.412C434.766 414.507 427.662 421.722 419.874 428.531C412.085 435.341 403.808 441.574 395.644 446.777L396.657 441.657C403.556 437.261 410.551 431.994 417.132 426.24C423.714 420.485 429.716 414.388 434.702 408.393L440.665 407.412Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M479.702 328.39C477.65 337.386 474.579 347.034 470.714 356.631C466.849 366.228 462.287 375.531 457.36 383.864L455.948 378.84C460.111 371.799 463.967 363.937 467.233 355.827C470.499 347.718 473.093 339.565 474.827 331.963L479.702 328.39Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M473.306 235.388C475.517 244.347 477.111 254.345 477.972 264.655C478.834 274.965 478.941 285.326 478.286 294.984L474.766 291.131C475.319 282.97 475.229 274.214 474.501 265.502C473.773 256.79 472.426 248.341 470.557 240.771L473.306 235.388Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M435.261 149.13C441 156.355 446.612 164.783 451.686 173.798C456.761 182.814 461.171 192.191 464.595 201.245L459.791 199.207C456.898 191.556 453.171 183.632 448.883 176.014C444.594 168.395 439.853 161.274 435.003 155.168L435.261 149.13Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M353.39 106.926C362.137 109.864 371.431 113.881 380.595 118.684C389.758 123.486 398.561 128.953 406.361 134.686L401.221 135.59C394.63 130.746 387.191 126.126 379.448 122.068C371.704 118.01 363.851 114.615 356.459 112.132L353.39 106.926Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2912 242.074C100.388 233.089 103.507 223.456 107.419 213.879C111.332 204.301 115.941 195.021 120.909 186.713L122.296 191.743C118.098 198.764 114.204 206.606 110.897 214.7C107.591 222.793 104.956 230.933 103.184 238.526L98.2912 242.074Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M158.592 141.864C165.506 135.753 173.626 129.706 182.363 124.165C191.099 118.623 200.231 113.725 209.092 109.83L207.31 114.735C199.822 118.027 192.105 122.165 184.722 126.848C177.34 131.531 170.478 136.641 164.636 141.805L158.592 141.864Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 224.863,
    cy: 147.205,
    rx: 3.5913,
    ry: 3.5913,
    transform: "rotate(-1.21534 224.863 147.205)",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 201.69,
    cy: 161.107,
    rx: 3.5913,
    ry: 3.5913,
    transform: "rotate(-1.21534 201.69 161.107)",
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 249.605,
    cy: 139.496,
    rx: 3.5913,
    ry: 3.5913,
    transform: "rotate(-1.21534 249.605 139.496)",
    fill: "white"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 276.832,
    cy: 136.045,
    rx: 3.5913,
    ry: 3.5913,
    transform: "rotate(-1.21534 276.832 136.045)",
    fill: "white"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 305.077,
    cy: 135.445,
    rx: 3.5913,
    ry: 3.5913,
    transform: "rotate(-1.21534 305.077 135.445)",
    fill: "white"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 332.038,
    cy: 142.057,
    rx: 3.5913,
    ry: 3.5913,
    transform: "rotate(-1.21534 332.038 142.057)",
    fill: "white"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 353.795,
    cy: 151.654,
    rx: 3.5913,
    ry: 3.5913,
    transform: "rotate(-1.21534 353.795 151.654)",
    fill: "white"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 373.707,
    cy: 164.642,
    rx: 3.5913,
    ry: 3.5913,
    transform: "rotate(-1.21534 373.707 164.642)",
    fill: "white"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 389.779,
    cy: 177.232,
    rx: 3.5913,
    ry: 3.5913,
    transform: "rotate(-1.21534 389.779 177.232)",
    fill: "white"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 403.988,
    cy: 192.257,
    rx: 3.5913,
    ry: 3.5913,
    transform: "rotate(-1.21534 403.988 192.257)",
    fill: "white"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 415.374,
    cy: 209.737,
    rx: 3.5913,
    ry: 3.5913,
    transform: "rotate(-1.21534 415.374 209.737)",
    fill: "white"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 425.325,
    cy: 227.247,
    rx: 3.5913,
    ry: 3.5913,
    transform: "rotate(-1.21534 425.325 227.247)",
    fill: "white"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 431.486,
    cy: 246.754,
    rx: 3.5913,
    ry: 3.5913,
    transform: "rotate(-1.21534 431.486 246.754)",
    fill: "white"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 435.335,
    cy: 270.14,
    rx: 3.5913,
    ry: 3.5913,
    transform: "rotate(-1.21534 435.335 270.14)",
    fill: "white"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 435.904,
    cy: 296.949,
    rx: 3.5913,
    ry: 3.5913,
    transform: "rotate(-1.21534 435.904 296.949)",
    fill: "white"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 432.642,
    cy: 323.84,
    rx: 3.5913,
    ry: 3.5913,
    transform: "rotate(-1.21534 432.642 323.84)",
    fill: "white"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 424.065,
    cy: 348.448,
    rx: 3.5913,
    ry: 3.5913,
    transform: "rotate(-1.21534 424.065 348.448)",
    fill: "white"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 411.107,
    cy: 369.797,
    rx: 3.5913,
    ry: 3.5913,
    transform: "rotate(-1.21534 411.107 369.797)",
    fill: "white"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 399.484,
    cy: 386.327,
    rx: 3.5913,
    ry: 3.5913,
    transform: "rotate(-1.21534 399.484 386.327)",
    fill: "white"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 383.542,
    cy: 402.47,
    rx: 3.5913,
    ry: 3.5913,
    transform: "rotate(-1.21534 383.542 402.47)",
    fill: "white"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 364.198,
    cy: 416.292,
    rx: 3.5913,
    ry: 3.5913,
    transform: "rotate(-1.21534 364.198 416.292)",
    fill: "white"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 342.858,
    cy: 426.323,
    rx: 3.5913,
    ry: 3.5913,
    transform: "rotate(-1.21534 342.858 426.323)",
    fill: "white"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 318.117,
    cy: 434.033,
    rx: 3.5913,
    ry: 3.5913,
    transform: "rotate(-1.21534 318.117 434.033)",
    fill: "white"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 292.815,
    cy: 437.922,
    rx: 3.5913,
    ry: 3.5913,
    transform: "rotate(-1.21534 292.815 437.922)",
    fill: "white"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 264.498,
    cy: 435.17,
    rx: 3.5913,
    ry: 3.5913,
    transform: "rotate(-1.21534 264.498 435.17)",
    fill: "white"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 238.016,
    cy: 428.548,
    rx: 3.5913,
    ry: 3.5913,
    transform: "rotate(-1.21534 238.016 428.548)",
    fill: "white"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 212.879,
    cy: 417.586,
    rx: 3.5913,
    ry: 3.5913,
    transform: "rotate(-1.21534 212.879 417.586)",
    fill: "white"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 192.477,
    cy: 404.129,
    rx: 3.5913,
    ry: 3.5913,
    transform: "rotate(-1.21534 192.477 404.129)",
    fill: "white"
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 174.877,
    cy: 387.26,
    rx: 3.5913,
    ry: 3.5913,
    transform: "rotate(-1.21534 174.877 387.26)",
    fill: "white"
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 159.61,
    cy: 367.468,
    rx: 3.5913,
    ry: 3.5913,
    transform: "rotate(-1.21534 159.61 367.468)",
    fill: "white"
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 146.146,
    cy: 342.37,
    rx: 3.5913,
    ry: 3.5913,
    transform: "rotate(-1.21534 146.146 342.37)",
    fill: "white"
  })), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 138.325,
    cy: 312.362,
    rx: 3.5913,
    ry: 3.5913,
    transform: "rotate(-1.21534 138.325 312.362)",
    fill: "white"
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.843,
    cy: 283.699,
    rx: 3.5913,
    ry: 3.5913,
    transform: "rotate(-1.21534 134.843 283.699)",
    fill: "white"
  })), _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 138.064,
    cy: 254.894,
    rx: 3.5913,
    ry: 3.5913,
    transform: "rotate(-1.21534 138.064 254.894)",
    fill: "white"
  })), _ellipse35 || (_ellipse35 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 147.528,
    cy: 226.915,
    rx: 3.5913,
    ry: 3.5913,
    transform: "rotate(-1.21534 147.528 226.915)",
    fill: "white"
  })), _ellipse36 || (_ellipse36 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 161.392,
    cy: 203.151,
    rx: 3.5913,
    ry: 3.5913,
    transform: "rotate(-1.21534 161.392 203.151)",
    fill: "white"
  })), _ellipse37 || (_ellipse37 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 178.629,
    cy: 180.275,
    rx: 3.5913,
    ry: 3.5913,
    transform: "rotate(-1.21534 178.629 180.275)",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_70_6",
    x: 0.520752,
    y: 0.520508,
    width: 570.958,
    height: 570.959,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 35,
    result: "effect1_foregroundBlur_70_6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup54);
export default __webpack_public_path__ + "static/media/Group 54.77c5653b2700086740c8eab509979d9b.svg";
export { ForwardRef as ReactComponent };